var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "tabContainer" } },
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ]
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "2",
                      type: "primary",
                      disabled: _vm.isAutoLoad
                    },
                    on: { click: _vm.autoLoadHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AutoAllocation")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "3",
                      type: "primary",
                      disabled: _vm.selectedContainerUsage === null
                    },
                    on: { click: _vm.autoUnloadHandler }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("SeaExport.CleanOutTheLoadingRecord")) +
                        " "
                    )
                  ]
                ),
                false
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "5", type: "primary" },
                        on: { click: _vm.downTemplateBtn_clickHandler }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("SeaExport.TemplateDownload")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                false
                  ? _c(
                      "el-upload",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "padding-left": "5px"
                        },
                        attrs: {
                          action: "string",
                          "http-request": _vm.importExcelEventHandler,
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "before-upload": _vm.beforeUploadUsage
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isEdit,
                                expression: "isEdit"
                              }
                            ],
                            attrs: { type: "primary" }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("SeaExport.CargoQuantityDescription")) +
                    "：" +
                    _vm._s(_vm.lbTotalDesc.lblContainerDesc) +
                    " " +
                    _vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")) +
                    "：" +
                    _vm._s(_vm.lbTotalDesc.lbTotalQuantity) +
                    " " +
                    _vm._s(_vm.$t("SeaExport.TotalWeight")) +
                    "：" +
                    _vm._s(_vm.lbTotalDesc.lbTotalWeight) +
                    " " +
                    _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                    "：" +
                    _vm._s(_vm.lbTotalDesc.lbTotalCubage) +
                    " "
                )
              ])
            ])
          ]
        )
      ]),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: {
          "config-module": "130150",
          "grid-options": _vm.gridOptions,
          "grid-params": _vm.gridParams,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.unitLoadDeviceUsages,
          "wrap-text": true
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          },
          gridReady: function(params) {
            return (_vm.gridApi = params.api)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }